import { useApiClient } from '@brewardapp/api-client';

const FlawBadge = ({ flaw }) => {
  const api = useApiClient();
  const { data: flawData, isLoading } = api.flaws.useFindFlaw(
    {
      filter: {
        id: flaw?.id,
      },
    },
    {
      enabled: !!flaw?.id,
    },
  );

  return (
    <div className="bg-error-500 mb-2 mr-2 w-fit rounded-xl px-4 py-2 shadow-lg">
      {isLoading ? (
        <div className="flex items-center justify-center">
          <div className="icon-[ph--spinner] h-4 w-4 animate-spin text-white" />
        </div>
      ) : (
        <div className="flex flex-row items-center">
          <div className="font-header mr-6 text-white">
            {flawData?.data?.name}
          </div>
          <div className="text-error-500 bg-base-500 flex h-6 w-6 items-center justify-center rounded-full font-sans text-sm font-bold font-semibold">
            {flaw?.frequency || flaw?.level}
          </div>
        </div>
      )}
    </div>
  );
};

export default FlawBadge;
